import { Component, inject, model, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { WebsiteConfigFormExpansionPanelComponent } from '../../website-config-form-expansion-panel/website-config-form-expansion-panel.component';

interface DialogData {
  displayName: string;
  filteredPagesNames: string[]
}

@Component({
    selector: 'app-delete-navbar-group-warning-dialog',
    standalone: true,
    imports: [
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        WebsiteConfigFormExpansionPanelComponent
    ],
    templateUrl: './delete-navbar-group-warning-dialog.component.html',
    styleUrl: './delete-navbar-group-warning-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteNavbarGroupWarningDialogComponent {
  readonly dialogRef = inject(MatDialogRef<DeleteNavbarGroupWarningDialogComponent>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  readonly displayName = model(this.data.displayName);
  readonly pages = model(this.data.filteredPagesNames);

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onDelete(): void {
    this.dialogRef.close(true); 
  }
}
